<p-dropdown
    class="w-100"
    styleClass="w-100"
    inputStyleClass="w-100"
    appendTo="body"
    dataKey="knownId"
    optionLabel="description"
    [filter]="showFilter"
    filterBy="description"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [options]="knowns"
    [(ngModel)]="selected"
    (ngModelChange)="onSelectionChange()">
</p-dropdown>

